import React, { useState, useRef } from 'react';
import { Growl } from 'primereact/growl';

import { ZonaDropZone } from './ZonaDropZone';
import { VistaDatos } from './VistaDatos';


const URL_PROCESAMIENTO_TXT = "movimientos/procesar_multiple.json";
const URL_CREAR_MOVIMIENTOS="movimientos/crear_movimientos_multiple.json";
export const MovimientosMasivos2022 = (props) => {

    let growl = useRef(null);
    const [datos,setDatos] =useState([]);

    const funcionProcesamiento = (dataResponse) => {        
        setDatos(dataResponse);
    }

    const funcionGuardadoServidor = (dataResponse) => {        
        setDatos([]);
    }

    return (<div>
        <Growl ref={growl} />
        <div className="p-grid">
            <div className="p-col-12">
                <div className="card">
                    <div className="card-title">Cargar archivos txt</div>
                    <p>Es esta sección usted puede cargar los archivos de los movimientos IMSS</p>
                    <p>Ahora puede:</p>
                    <ul>
                        <li>Cargar un solo .txt con todos sus registros patronales</li>
                        <li>En caso de que cargue 2 o más archivos del mismo registro patronal se agruparán y serán enviados al IMSS como uno solo</li>
                    </ul>
                </div>
            </div>
            <div className="p-col-12">
                <div className="card">
                    <ZonaDropZone growl={growl} urlProcesoTxt={URL_PROCESAMIENTO_TXT} 
                    urlCrearMovimientos={URL_CREAR_MOVIMIENTOS} funcionProcesamiento={funcionProcesamiento} 
                    funcionGuardadoServidor = {funcionGuardadoServidor}/>
                </div>
            </div>
            <div className="p-col-12">
                <div className="card">
                    <VistaDatos datos={datos}/>
                </div>
            </div>
        </div>
    </div>);
}